import { render, staticRenderFns } from "./LbsTermList.vue?vue&type=template&id=be2fbcfe&"
import script from "./LbsTermList.vue?vue&type=script&lang=js&"
export * from "./LbsTermList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports